import { useMutation } from 'react-query';
import { urlWithParams } from '../../CommonUtils/urlWithParams';
import { authFetchBlob } from '../../CommonUtils/authFetchBlob';

interface FetcherParams {
  clientId: string;
  date: string;
  accountId: string;
  groupId: string;
  selectedGroupName: string;
}

const downloadPositionsDetailsCsv = async ({
  clientId,
  accountId,
  groupId,
  date,
  selectedGroupName,
}: FetcherParams) => {
  return authFetchBlob(
    urlWithParams(
      '/Consumer/OrionAccountsWidgets/DownloadPositionsDetailsCsv',
      {
        clientId,
        asOfDate: date,
        accountId: accountId || null,
        groupId: groupId || null,
        selectedGroupName,
      },
      { skipNulls: true },
    ),
  );
};

export const usePositionsDetailsCsvMutation = () => {
  return useMutation(downloadPositionsDetailsCsv);
};
